import { useMemo } from "react";
import { Sprite } from "@pixi/react";
import type { Resource, Texture } from "pixi.js";
import type { IFloorPayload } from "../../Domain/Types/FloorPlan/FloorPayload.type";
import { resolveFloorPlanCanvasSize } from "../../Functions/floorPlanCanvas.functions";

export type FloorPlanBackgroundFloorPlan = Pick<IFloorPayload, "viewport" | "zones" | "places">;

export type FloorPlanBackgroundProps = {
  texture: Texture<Resource>;
  floorPlan: FloorPlanBackgroundFloorPlan;
  /** Pixi display name; Create uses this for canvas capture. */
  name?: string;
  "data-testid"?: string;
};

/**
 * Outline layer only: sizes the background sprite from image vs viewport coordinate space.
 * Place/zone sprites stay in sibling containers at raw world coordinates.
 */
export function FloorPlanBackground({
  texture,
  floorPlan,
  name,
  "data-testid": dataTestId = "floor-plan-background"
}: FloorPlanBackgroundProps) {
  const canvasSize = useMemo(
    () => resolveFloorPlanCanvasSize(floorPlan, texture),
    [floorPlan, texture]
  );

  return (
    <Sprite
      texture={texture}
      name={name}
      data-testid={dataTestId}
      width={canvasSize.width}
      height={canvasSize.height}
    />
  );
}
